import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';
import { TableWrapper, Heading, NameSection } from './chatBlockStyled'
import styles from './chatBlock.module.scss'
import xIcon from 'web/assets/images/XIcon.png';
import ChatUserIcon from 'web/assets/svg/ChatUserIcon';
import ChatSendIcon from 'web/assets/images/ChatSendIcon.png';
import AdminChatIcon from 'web/assets/images/AdminChatIcon.png';
import { fetchAllChatList, sendAdminChatMessage, makeMessagesRead } from '../../../../../redux/actions/admin';

function ChatBlock() {
  const dispatch = useDispatch();
  let history = useHistory()
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const [displayDiv, setDisplayDiv] = useState('nameList')
  const [message, setMessage] = useState('')
  const [chatNameList, setChatNameList] = useState([])
  const [userChats, setUserChats] = useState([])
  const [selectedUser, setSelectedUser] = useState({})

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    const intervalCall = setInterval(() => {
      fetchMessageList();
    }, 5000);
    return () => clearInterval(intervalCall)
  }, [])

  useEffect(() => {
    //update the chat list of that user
    if (displayDiv === 'chatList' && chatNameList) {
      let id = selectedUser.userId
      let chatMessagesOfUser = chatNameList.filter(data => data.userId === id)
      setUserChats(chatMessagesOfUser && chatMessagesOfUser.length > 0 && chatMessagesOfUser[0].chatMessages)
    }
  }, [chatNameList])

  const fetchMessageList = async () => {
    let response = '';
    response = await dispatch(fetchAllChatList());
    if (response.status === 'SUCCESS') {
      if (response.payload) {
        let unreadMsg = [], readMsg = []
        response.payload.map((data, index) => {
          let unreadCount
          const { chatMessages } = data
          if (chatMessages && chatMessages !== null) unreadCount = chatMessages.filter(val => (!val.readByAdmin && val.readByAdmin !== null)).length
          if (unreadCount > 0) unreadMsg.push(data)
          else readMsg.push(data)
        })
        setChatNameList([...unreadMsg, ...readMsg])
      }
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      }
    }
  }

  const personChatClick = async (data) => {
    setUserChats(data.chatMessages)
    setSelectedUser(data)
    setDisplayDiv('chatList')
    let response = await dispatch(makeMessagesRead(data));
  }

  const sendMessage = async (e) => {
    if (message?.trim() === '') setMessage(message?.trim())
    if (message?.trim() !== '' && (e === 'send' || (e.keyCode === 13 && !e.shiftKey))) {
      let userAuthId = localStorage.getItem('adminAuthId')
      let data = {
        userId: selectedUser && selectedUser.userId,
        message: message,
        userType: "ADMIN",
        senderId: userAuthId,
        receiverId: selectedUser && selectedUser.userId
      }
      let response = '';
      response = await dispatch(sendAdminChatMessage(data));
      if (response.status === 'SUCCESS') {
        fetchMessageList();
        setMessage('')
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        }
      }
    }
  }

  return (
    <>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('ORDER_CHAT') || adminRoles.includes('CHAT'))) ?
        <>
          <TableWrapper>
            <Heading>
              <div className={styles.listingDiv}>
                <img src={AdminChatIcon} alt="AdminChatIcon" />
                <h3>{displayDiv === 'nameList' ? 'User Listing' :
                  (selectedUser.userDetail && selectedUser.userDetail.name) ? selectedUser.userDetail.name : 'NA'}</h3>
              </div>
              {displayDiv === 'chatList' &&
                <img className={styles.xIcon} src={xIcon} alt="X-Icon" onClick={() => setDisplayDiv('nameList')} />
              }
            </Heading>

            {displayDiv === 'nameList' &&
              <div style={{ height: '100%' }}>
                <div style={{ height: '80%', overflow: 'auto' }}>
                  {chatNameList && chatNameList.map((data, index) => {
                    let unreadCount = 0
                    const { chatMessages } = data
                    if (chatMessages && chatMessages !== null) {
                      unreadCount = chatMessages.filter(val => (!val.readByAdmin && val.readByAdmin !== null)).length
                    }
                    return (
                      <>
                        <NameSection onClick={() => personChatClick(data)}>
                          <div>
                            <h6>{data.userDetail && data.userDetail.name ? data.userDetail.name : 'NA'}</h6>
                            <span>{moment(data.lastUpadated * 1000).format('MMM Do, YYYY, HH:mm')}</span>
                          </div>
                          {unreadCount > 0 ? <p title={`${unreadCount} ${unreadCount > 1 ? 'unread messages' : 'unread message'}`}>{unreadCount}</p> : <></>}
                        </NameSection>
                        <hr style={{ margin: '0px 48px 0px 30px' }} />
                      </>
                    )
                  })}
                  {chatNameList && chatNameList.length === 0 && <p style={{ textAlign: 'center', paddingTop: '90px' }}>Loading...</p>}
                </div>
              </div>
            }

            {displayDiv === 'chatList' &&
              <div style={{ height: '88%' }}>
                <div style={{ height: 'calc(100vh - 296px)', overflow: 'auto', display: 'flex', flexDirection: 'column-reverse', paddingBottom: '25px' }}>
                  <div>
                    {userChats && userChats.map(data => {
                      return (
                        <div className={styles.chatPanel}>
                          <div class={data.userType === 'USER' ? "col-md-9" : "col-md-9 offset-md-3"}>
                            <div className={data.userType === 'USER' ? styles.chatBoxLeft : styles.chatBoxRight}>
                              <ChatUserIcon color={data.userType === 'USER' ? "#6d7b69" : "#0a5587"} />
                              <div style={{ maxWidth: '85%', wordWrap: 'break-word' }}>
                                <p className={data.userType === 'USER' ? `${styles.chatBubbleL} ${styles.chatBubbleLLeft}` : `${styles.chatBubbleR} ${styles.chatBubbleRRight}`}>
                                  {data.message}
                                </p>
                                <span className={data.userType === 'USER' ? styles.dateCssLeft : styles.dateCssRight}>{moment(data.created * 1000).format('MMM Do, YYYY, HH:mm')}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
                <hr style={{ margin: '6px 48px 11px 31px' }} />
                <div className={styles.footer}>
                  <textarea placeholder="Type message.." name="msg" required value={message} onChange={e => setMessage(e.target.value)}
                    onKeyUp={e => sendMessage(e)}></textarea>
                  <button className={styles.enterBtn} >
                    <img src={ChatSendIcon} onClick={() => sendMessage('send')} />
                  </button>
                </div>
              </div>
            }

          </TableWrapper>
        </>

        :

        <p>You are not authorized to view this page.</p>
      }
    </>
  );
}

export default ChatBlock;